import { connect } from 'react-redux';
import { EXCHANGE_TYPEAHEAD_CLEAR, EXCHANGE_DATEPICKER_CHANGE } from 'constants/ActionTypes';
import { errorTripExchange, validateExchange } from '../../../actions/exchange';
import ExchangeSecondStep from './ExchangeSecondStep';

const mapStateToProps = ({ purchase, exchange, code }) => {
  const { originSlug, originDisplay, destinationDisplay, destinationSlug, date } = exchange.trip;
  const currentTicket = exchange.ticket.operationNumber;
  const { errorTrip } = exchange;

  return {
    isFetching: purchase.get('isFetching'),
    token: purchase.get('token'),
    // Set by the purchase reducer from `preSelectedSeats`, the same signal `NewPurchase` uses to
    // skip the seats step on the regular search flow. Read field by field rather than handing the
    // whole slice over, so this step does not re-render on every unrelated purchase update.
    hasSelectedSeats: Boolean(purchase.get('hasSelectedSeats')),
    originSlug,
    originDisplay,
    destinationDisplay,
    destinationSlug,
    date,
    currentTicket,
    code,
    errorTrip,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setDate: (date) => dispatch({ type: EXCHANGE_DATEPICKER_CHANGE, date }),
    clearTypeahead: (origin, destination) =>
      dispatch({
        type: EXCHANGE_TYPEAHEAD_CLEAR,
        origin,
        destination,
      }),
    errorTripExchange: (errorTrip) => dispatch(errorTripExchange(errorTrip)),
    // Positional pass-through to the `validateExchange` action creator; `transporter` is the
    // 9th argument `ExchangeSecondStep` passes (task 8.5) and has to be declared here, or JS
    // drops it and the revalidation POST goes out with no line.
    validateExchange: (
      history,
      email,
      document,
      operationNumbers,
      NIT,
      origin,
      destination,
      recaptchaToken,
      transporter,
    ) =>
      dispatch(
        validateExchange(
          history,
          email,
          document,
          operationNumbers,
          NIT,
          origin,
          destination,
          recaptchaToken,
          transporter,
        ),
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeSecondStep);
